import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const StudentGrievance = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const antiRaggingSquad = [
    { name: "Mr. R. D. Jadhav", position: "HOH" },
    { name: "Mr. Padmakar Phad", position: "Assist. Director, Sports" },
    { name: "Mr. Sanjay Kumawat", position: "Sr. Warden" },
    { name: "Mr. Pravin Shewale", position: "Sr. Warden" },
    { name: "Mr. Pandit Lad", position: "Sr. Warden" },
    { name: "Mr. Nana Thorat", position: "Parade Instructor" },
    { name: "Cadet Yuraj Sandilya", position: "B.Tech (ME), IV year" },
    { name: "Cadet Santosh Sankar Sathya", position: "B.Tech (ME), IV year" },
    { name: "Cadet Sneha Negi", position: "B.Tech (ME), IV year" },
    { name: "Cadet Faraz Khan", position: "B.Sc (NS), III year" },
  ];

  const womensCommittee = [
    { name: "Capt. Prerit Misra, Principal", position: "Chairman" },
    {
      name: "Dr. Vrushali Rampure, Teaching representative",
      position: "Co-Chairman",
    },
    { name: "Mrs. Asha Thomas, Administration", position: "Secretary" },
    {
      name: "Prof. (Mrs.) Seema Pundale, Teaching representative (B. Tech.)",
      position: "Members",
    },
    {
      name: "Prof. (Mrs.) Nilambari Jadhav, Teaching representative (B. Sc.)",
      position: "Members",
    },
    {
      name: "Mrs. Sheetal Dhautre, Non-Teaching Representative",
      position: "Members",
    },
    {
      name: "Cdt. Tanvi Shinde - Student representative, VIIth semester",
      position: "Members",
    },
  ];

  const studentCommittee = [
    { name: "Capt. Prerit Misra, Principal", position: "Chairman" },
    { name: "Prof. Shrikant Gunjal, Vice Principal", position: "Co-Chairman" },
    { name: "Prof. Shailesh Prasad", position: "Secretary" },
    { name: "Dr. Pratibha Jagtap", position: "Member" },
    {
      name: "Capt. Kashish Sharma, Head of Nautical Science",
      position: "Member",
    },
    { name: "C/E Sunil Kolte", position: "Member" },
    { name: "Prof. Eknath Pore", position: "Member" },
    { name: "Mr. Ravindra Jadhav, HOD- Hostel", position: "Member" },
    {
      name: "Cdt. Aryan More, B.Tech.- Marine Engineering",
      position: "Member",
    },
    {
      name: "Cdt. Harmandeep Kaur Kulvinder Singh Bhamra, B.Sc.- Nautical Science",
      position: "Member",
    },
  ];

  return (
    <div>
      <h1 className="title">Students Grievance</h1>
      <hr />
      <div className="page-content-container">
        {/* <h4 className="innerpage-subheading">Procedure</h4> */}
        <p>
          To give in writing the complaint of any grievance reported by the
          women staff or student to the chairman / Co- Chairman of the
          committee. Regular meetings to be conducted to decide the further
          proceedings or steps to be taken accordingly. Upon receiving any
          complaint, one or more members should first discuss with the aggrieved
          person about the genuineness and gravity of the situation and
          accordingly advise her to give a written complaint.
        </p>

       
        {/* ---------- Accordion 1 ---------- */}
        <Accordion
          title="What Is Sexual Harassment in The Workplace?"
          isActive={activeIndex === 0}
          onClick={() => handleToggle(0)}
        />
        {activeIndex === 0 && (
          <div className="accordion-content">
            <p>
              Sexual harassment in the workplace refers to a verbal or physical
              act with a sexual nature, performed in recruitment or in the
              workplace by a boss, manager, employee, client or customer of a
              working unit, that is unwelcomed by the person receiving it and
              has caused the person to feel violated, insulted, and being in an
              unbearable hostile environment.
            </p>

            <ul className="page-content-lists">
              <li>The verbal or physical acts with a sexual nature include:</li>
              <li>Joking or teasing with a sexual nature.</li>
              <li>
                Continuous invitation to dinner or date despite rejection.
              </li>
              <li>
                Intentional dissemination of hearsay with a sexual nature.
              </li>
              <li>Enquiring for or sharing sexual experience.</li>
              <li>
                Spreading and displaying a nude image with apparent sexual
                contents.
              </li>
              <li>Request for sexual intercourse.</li>
              <li>Unnecessary physical contact.</li>
              <li>Forced sexual intercourse, etc.</li>
            </ul>

            <p>
              Workplace covers any place under the direct or indirect control of
              the employer that an employee needs to be present or go to in
              order to carry out work. It includes office and other locations
              where the job responsibilities are undertaken, such as offices of
              clients, destinations of business trips, venues of business
              lunch/dinner, business branches, homes of clients, etc. and the
              appropriate extension of the workplace, such as excursions, social
              activities, staff gatherings after work that are organized by the
              company.
            </p>
          </div>
        )}

        {/* ---------- Accordion 2 ---------- */}
        <Accordion
          title="What Are The Forms Of Sexual Harassment In The Workplace?"
          isActive={activeIndex === 1}
          onClick={() => handleToggle(1)}
        />
        {activeIndex === 1 && (
          <div className="accordion-content">
            <p>
              Sexual harassment manifests itself in different forms - verbal,
              physical, visual and psychological. Some examples are:
            </p>
            <p>
              <h4 className="innerpage-subheading">Verbal:</h4>
              Two male co-workers are constantly teasing with dirty jokes, even
              when women are within hearing distance. Their jokes range from
              being mildly crude to downright vulgar. A female co-worker has
              tried to tell them to stop but they tell her, "It's just a joke.
              Can't you take a joke?" It is not "just a joke". Since she has
              clearly stated that she wanted them to stop, they should at least
              have the courtesy to share their jokes in private. This is verbal
              harassment.
            </p>
            <p>
              <h4 className="innerpage-subheading">Physical:</h4>A male co-worker
              or boss sometimes gives lady clerk a pat on the shoulder as a way
              of saying she has done a good job. Lately however, the action has
              become more physical - resting his hand on hers, putting his arms
              around her shoulder, occasionally brushing against her
              "accidentally". This is physical harassment.
            </p>
            <p>
              <h4 className="innerpage-subheading">Visual:</h4>A male co-worker or
              superior has calendars and pictures of scantily clad women in
              suggestive poses placed prominently in his work area. Women
              workers are embarrassed whenever they must speak with him in his
              office and have mentioned their discomfort to him. He sees nothing
              wrong with these pictures however, arguing that "It is a free
              country". Not when the pictures are indecent and obscene. This is
              visual harassment.
            </p>
            <p>
              <h4 className="innerpage-subheading">Psychological :</h4>A male
              co-worker or superior has shown an interest in female co-worker,
              but she is not keen on accepting his dates and have openly and
              clearly made known her disinterest and disapproval. Yet he
              persists, showering her with signs of his affection by leaving
              flowers on her table, dropping hints and finding ways to be alone
              with her, even making hidden threats. This is psychological
              harassment.
            </p>
          </div>
        )}

        {/* ---------- Accordion 3 ---------- */}
        <Accordion
          title="Hostel Level Anti-Ragging Squads"
          isActive={activeIndex === 2}
          onClick={() => handleToggle(2)}
        />
        {activeIndex === 2 && (
          <div className="accordion-content">
            <table className="page-content-table" >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Position</th>
                </tr>
              </thead>
              <tbody>
                {antiRaggingSquad.map((member, index) => (
                  <tr key={index}>
                    <td>{member.name}</td>
                    <td>{member.position}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* ---------- Accordion 4 ---------- */}
        <Accordion
          title="Women Grievance Redressal Committee"
          isActive={activeIndex === 3}
          onClick={() => handleToggle(3)}
        />
        {activeIndex === 3 && (
          <div className="accordion-content">
            <p>
              The Government of India through a directive of the Supreme Court
              of India requires that all organizations / Institutes have a watch
              dog / a committee to address issues of sexual harassment that may
              come up from time to time. A cell or committee comprising male &
              female members is required to investigate all complaints of sexual
              harassment, for which a documented procedure is to be made a part
              of the QMS or something akin by way of Company rules. A committee
              is constituted for prevention/action against sexual harassment of
              female teaching staff, non-teaching staff and girl student as
              outlined below:
            </p>
  
            <table className="page-content-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Position</th>
                </tr>
              </thead>
              <tbody>
                {womensCommittee.map((member, index) => (
                  <tr key={index}>
                    <td>{member.name}</td>
                    <td>{member.position}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* ---------- Accordion 2 ---------- */}
        <Accordion
          title="Student Grievance Redressal Committee"
          isActive={activeIndex === 4}
          onClick={() => handleToggle(4)}
        />
        {activeIndex === 4 && (
          <div className="accordion-content">
            <table className="page-content-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Position</th>
                </tr>
              </thead>
              <tbody>
                {studentCommittee.map((member, index) => (
                  <tr key={index}>
                    <td>{member.name}</td>
                    <td>{member.position}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentGrievance;
